import { render, staticRenderFns } from "./newconciliationconfig.vue?vue&type=template&id=6b25197b&scoped=true&"
import script from "./newconciliationconfig.vue?vue&type=script&lang=js&"
export * from "./newconciliationconfig.vue?vue&type=script&lang=js&"
import style0 from "./newconciliationconfig.vue?vue&type=style&index=0&id=6b25197b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b25197b",
  null
  
)

export default component.exports